export enum RTFSettingsTab {
  logProfiles = 'logProfiles',
  logLevels = 'logLevels',
  flushLogs = 'flushLogs',
  configurationManagement = 'configurationManagement',
  activityLog = 'activityLog',
  logsHistory = 'logsHistory',
}

export const SIDEBAR_ITEMS_GROUPS_MAP = {
  settings: [RTFSettingsTab.logProfiles, RTFSettingsTab.logLevels, RTFSettingsTab.flushLogs, RTFSettingsTab.configurationManagement],
  history: [RTFSettingsTab.activityLog, RTFSettingsTab.logsHistory]
}
